import { pipe } from 'fp-ts/function';
import { array, string } from 'fp-ts';
import { PortfolioRateGroupOverview } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';

export const getBulkLinkVariables = (selectedRateGroups: PortfolioRateGroupOverview[]) => {
    const hasRowsSelected = selectedRateGroups.length > 0;
    const areSomeSelectedRateGroupsLinked = selectedRateGroups.some((rateGroup) => rateGroup.isPortfolioManaged);
    const areSomeSelectedRateGroupsFromSameEnterprise = pipe(
        selectedRateGroups,
        array.map((rateGroup) => rateGroup.enterpriseId),
        array.uniq(string.Eq),
        array.size,
        (enterpriseCount) => enterpriseCount < selectedRateGroups.length
    );
    const selectedRateGroupsHaveSameServiceKey = selectedRateGroups.every(
        (rateGroup) => rateGroup.serviceKey === selectedRateGroups[0].serviceKey
    );
    const serviceKey = selectedRateGroups.length > 0 && selectedRateGroups[0].serviceKey;

    const hasRowsSelectedTooltipTextKey = !hasRowsSelected && TextKey.LinkCentralCTATooltipNotSelected;
    const areSomeSelectedRateGroupsLinkedTooltipTextKey =
        areSomeSelectedRateGroupsLinked &&
        selectedRateGroups.length === 1 &&
        TextKey.LinkCentralCTATooltipAlreadyLinked;
    const hasEmptyServiceKeyTooltipTextKey = !serviceKey && TextKey.LinkCentralCTATooltipServiceKeyNotDefined;

    const isLinkButtonDisabled =
        !hasRowsSelected ||
        areSomeSelectedRateGroupsLinked ||
        areSomeSelectedRateGroupsFromSameEnterprise ||
        !selectedRateGroupsHaveSameServiceKey ||
        !serviceKey;

    const linkingDisabledTooltipTextKey =
        hasRowsSelectedTooltipTextKey ||
        areSomeSelectedRateGroupsLinkedTooltipTextKey ||
        hasEmptyServiceKeyTooltipTextKey ||
        TextKey.LinkCentralCTATooltipServicePropertyDifferent;

    return {
        isLinkButtonDisabled,
        linkingDisabledTooltipTextKey,
    };
};
